// Components imports
import SuccessStoryComponent from "../../../shared/components/success-story/success-story.component";

import { RAISE_TAX_SUCCESS_PROP_DATA } from "../../../shared/constants/shared.contants";

/**
 * RaiseTaxSuccessStoryComponent is a functional component that displays a success story section with a description and an image.
 *
 * @component
 * @returns {React.JSX.Element}
 */

const RaiseTaxSuccessStoryComponent = (): React.JSX.Element => {
    return <SuccessStoryComponent successData={RAISE_TAX_SUCCESS_PROP_DATA} />;
};

export default RaiseTaxSuccessStoryComponent;
